import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	EventEmitter,
	Input,
	OnChanges,
	Output,
	SimpleChanges
} from "@angular/core";

import {CalendarView, SelectionRangeEnd} from '@progress/kendo-angular-dateinputs';

import * as moment from 'moment';

import {LogCat, LogManager} from "../../../log";

import {IDateRange, IKenodDateRange} from "../date.range.picker/date.range.picker.interface";

import {TranslateService} from "../../../../common/translate";
import {RtlService} from "../../../rtl/services/rtl.service";
//import {unitOfTime} from "moment";

/*
* Selector: cp-date-range-picker-calendar
* Change Detection: OnPush
* View Encapsulation: Emulated
*
* Inputs:
* dateRange: IDateRange			//
* disabled: boolean				// Optional
*
* Outputs:
* onChange?: EventEmitter<IDateRange>	// Optional, for emitting event: { from: Date, to: Date }
* */
@Component({
	selector:'cp-date-range-picker-calendar',
	templateUrl: './date.range.picker.calendar.html',
	styleUrls: ['./date.range.picker.calendar.scss'],
	changeDetection:ChangeDetectionStrategy.OnPush
})
export class DateRangePickerCalendarComponent implements OnChanges{// OnInit,

	@Input() dateRange: IDateRange;
	@Input() disabled: boolean = false;

	@Output() onChange?: EventEmitter<IDateRange> = new EventEmitter<IDateRange>(false);

	public selectionRange: IKenodDateRange = { start: null, end: null };
	public focusedDate: Date;
	public activeRangeEnd: SelectionRangeEnd = "end";
	public activeView: CalendarView = "month";
	//public dictionary: any = {};

	constructor(private changeDetectorRef:ChangeDetectorRef,
				private translateService:TranslateService,
				private rtlService: RtlService) {
		LogManager.debug(LogCat.RisWorklistCategories.DateFilter,"DateRangePickerCalendarComponent.constructor");
	}

	public ngOnChanges(changes: SimpleChanges){
		LogManager.debug(LogCat.RisWorklistCategories.DateFilter,"DateRangePickerCalendarComponent.ngOnChanges");
		this.updateSelectionRange();
	}

	// public ngOnInit(){
	// 	LogManager.debug(LogCat.RisWorklistCategories.DateFilter,"DateRangePickerCalendarComponent.ngOnInit");
	// 	this.initDictionary();
	// }

	/*
	* Handle On Calendar Selection Range Change
	* */
	public handleSelectionRangeChange($event: IKenodDateRange) {
		LogManager.debug(LogCat.RisWorklistCategories.DateFilter,"DateRangePickerCalendarComponent.handleSelectionRangeChange");
		let momentFromDate = moment($event.start);
		let momentToDate = moment($event.end);
		if (this.activeRangeEnd === 'end' && momentFromDate.isBefore(momentToDate)) {
			this.selectionRange = { start: momentFromDate.toDate(), end: momentToDate.toDate() };
			//this.focusedDate = momentToDate.toDate();
			this.onChange.emit({ from: momentFromDate.toDate(), to: momentToDate.toDate() });
		} else {
			this.selectionRange = { start: momentFromDate.toDate(), end: momentFromDate.toDate() };
			//this.focusedDate = momentFromDate.toDate();
		}
	}

	/*
	* Update focused date:
	* set focused date one previous (negative number)/next (positive number) month
	* */
	// public updateFocusedDate(value: number) {
	// 	LogManager.debug(LogCat.RisWorklistCategories.DateFilter,"DateRangePickerCalendarComponent.updateFocusedDate");
	// 	let val = this.rtlService.isRtl() ? (-1) * value : value;
	// 	let momentUnits:unitOfTime.Base;
	// 	switch (this.activeView) {
	// 		case "century":
	// 			momentUnits="years";
	// 			val=val*100;
	// 			break;
	// 		case "decade":
	// 			momentUnits="years";
	// 			val=val*10;
	// 			break;
	// 		case "month":
	// 			momentUnits="month";
	// 			break;
	// 		case "year":
	// 			momentUnits="years";
	// 			break;
	// 	}
	// 	this.focusedDate = moment(this.focusedDate).add( val, momentUnits).toDate();
	// 	// make sure we're not passed the min and max
	// 	let maxKendoDate=new Date(2099,0,0);
	// 	let minKendoDate=new Date(1900,0,0);
	// 	if (moment(this.focusedDate).isAfter(moment(maxKendoDate))){
	// 		this.focusedDate = maxKendoDate;
	// 	}else if (moment(this.focusedDate).isBefore(moment(minKendoDate))){
	// 		this.focusedDate=minKendoDate;
	// 	}
	// }
	//
	// public isLaterCalendarAvailable():boolean{
	// 	let retVal:boolean;
	// 	switch (this.activeView) {
	// 		case "century":
	// 			retVal= (moment(this.focusedDate).isBefore(moment(new Date(2000,0,0))));
	// 			break;
	// 		case "decade":
	// 			retVal=  (moment(this.focusedDate).isBefore(moment(new Date(2090,0,0))));
	// 			break;
	// 		case "year":
	// 			retVal= (moment(this.focusedDate).isBefore(moment(new Date(2099,0,0))));
	// 			break;
	// 		case "month":
	// 			retVal= (moment(this.focusedDate).isBefore(moment(new Date(2099,11,0))));
	// 			break;
	// 	}
	// 	return retVal;
	// }
	//
	// public isEarlierCalendarAvailable():boolean{
	// 	let retVal:boolean;
	// 	switch (this.activeView) {
	// 		case "century":
	// 			retVal= (moment(this.focusedDate).isAfter(moment(new Date(1990,0,0))));
	// 			break;
	// 		case "decade":
	// 			retVal= (moment(this.focusedDate).isAfter(moment(new Date(1909,0,0))));
	// 			break;
	// 		case "year":
	// 			retVal=(moment(this.focusedDate).isAfter(moment(new Date(1900,0,0))));
	// 			break;
	// 		case "month":
	// 			retVal=(moment(this.focusedDate).isAfter(moment(new Date(1900,0,0))));
	// 			break;
	// 	}
	// 	return retVal;
	// }
	/*
	* Initialize component's dictionary
	* */
	// private initDictionary() {
	// 	LogManager.debug(LogCat.RisWorklistCategories.DateFilter,"DateRangePickerCalendarComponent.initDictionary");
	// 	let isRtl: boolean = this.rtlService.isRtl();
	// 	this.dictionary = {
	// 		left_arrow: this.translateService.instant(isRtl ? "NEXT_MONTH": "PREVIOUS_MONTH", {}),
	// 		right_arrow: this.translateService.instant(isRtl ? "PREVIOUS_MONTH" : "NEXT_MONTH", {})
	// 	};
	// }

	/*
	* Check if date range is valid
	* */
	private isValidDateRange(dateRange: IDateRange) {
		LogManager.debug(LogCat.RisWorklistCategories.DateFilter,"DateRangePickerCalendarComponent.isValidDateRange");
		if (dateRange &&
			dateRange instanceof Object &&
			dateRange.from &&
			moment.isDate(dateRange.from) &&
			dateRange.to &&
			moment.isDate(dateRange.to) &&
			moment(dateRange.to).isSameOrAfter(dateRange.from)) {
			return true;
		}
		return false;
	}

	/*
	* Update the kendo calendar ate selection range
	* */
	private updateSelectionRange() {
		LogManager.debug(LogCat.RisWorklistCategories.DateFilter,"DateRangePickerCalendarComponent.updateSelectionRange");
		if (this.isValidDateRange(this.dateRange)) {
			this.activeRangeEnd = "start";
			this.focusedDate = this.dateRange.from;
			this.selectionRange.start = this.dateRange.from;
			this.selectionRange.end = this.dateRange.to;
		} else {
			this.focusedDate = new Date();
		}
	}
}

